export const Sales = {
  path: '/sales',
  component: () => import('@/View/Sales/Layout/Layout.vue'),
  hidden: true,
  redirect: '/sales/dashboard',
  name: 'Sales',
  meta: {
    icon: 'dashboard',
    title: 'Sales',
    selected: true,
    breadCrumb: 'Sales',
    permissionList: ['abc', 'def']
  },
  children: [
    { // Sales dashboard start
      path: '/sales/dashboard',
      component: () => import('@/View/Sales/Dashboard/dashboard.vue'),
      hidden: false,
      icon: 'dashboard',
      name: 'SaleDashboard',
      meta: {
        icon: 'dashboard',
        breadCrumb: 'Sales',
        title: 'Dashboard',
        selected: true,
        permissionList: ['abc', 'def']
      }
    },
    { // Sales activityLog
      path: '/sales/activityLog',
      component: () => import('@/View/Sales/ActivityLog/ActivityLog.vue'),
      hidden: false,
      icon: 'fas fa-clock',
      name: 'SalesActivityLog',
      meta: {
        breadCrumb: 'ActivityLog',
        icon: 'fas fa-clock',
        title: 'ActivityLog',
        selected: true,
        permissionList: ['abc', 'def']
      },
      children: []
    },
    // Sales Invoice
    {
      path: '/sales/invoice',
      component: () => import('@/View/Sales/main/index.vue'),
      hidden: false,
      icon: 'fas fa-file-invoice',
      name: 'Invoice',
      redirect: '/sales/invoice/list',
      meta: {
        breadCrumb: 'Invoice',
        icon: 'fas fa-file-invoice',
        title: 'Invoice',
        selected: true,
        permissionSlug: 'invoice',
        permissionList: ['isViewAll', 'isViewRelated']
      },
      children: [
        // Sales Invoice List
        {
          path: '/sales/invoice/list',
          component: () => import('@/View/Sales/Invoice/InvoiceList.vue'),
          hidden: false,
          name: 'List',
          meta: {
            breadCrumb: 'Invoice',
            title: 'Invoice List',
            selected: true
          }
        },
        // Add Invoice
        {
          path: '/sales/invoice/new/:invoiceId/:from/:customerId',
          component: () => import('@/View/Sales/Invoice/NewInvoice.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'NewInvoice',
          meta: {
            breadCrumb: 'New Invoice',
            title: 'Add',
            selected: true,
            permissionSlug: 'invoice'
          }
        },
        {
          path: '/sales/invoice/details/:invoiceId',
          component: () => import('@/View/Sales/Invoice/InvoiceDetails.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'InvoiceDetails',
          meta: {
            breadCrumb: 'Invoice Details',
            title: 'Details',
            selected: true,
            permissionSlug: 'invoice'
          }
        },
        {
          path: '/sales/invoice/view/:invId',
          component: () => import('@/View/Sales/Invoice/ViewInvoice.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'ViewInvoice',
          meta: {
            breadCrumb: 'Invoice',
            title: 'Invoice View',
            selected: true,
            permissionSlug: 'invoice'
          }
        }
      ]
    },
    {
      path: '/sales/payment',
      component: () => import('@/View/Sales/main/index.vue'),
      hidden: false,
      icon: 'fas fa-money-check-alt',
      name: 'Payments',
      redirect: '/sales/payment/list',
      meta: {
        breadCrumb: 'Payment',
        icon: 'fas fa-money-check-alt',
        title: 'Payments',
        selected: true,
        permissionSlug: 'payment',
        permissionList: ['isViewAll', 'isViewRelated']
      },
      children: [
        // Sales payment List
        {
          path: '/sales/payment/list',
          component: () => import('@/View/Sales/Payment/Paymentlist.vue'),
          hidden: false,
          name: 'PaymentList',
          meta: {
            breadCrumb: 'Payments',
            title: 'List',
            selected: true
          }
        },
        // Add Payment
        {
          path: '/sales/payment/new/:paymentId/:customerId',
          component: () => import('@/View/Sales/Payment/NewPayment.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'NewPayment',
          meta: {
            breadCrumb: 'New Payment',
            title: 'Add',
            selected: true,
            permissionSlug: 'payment'
          }
        },
        {
          path: '/sales/payment/details/:paymentId',
          component: () => import('@/View/Sales/Payment/PaymentDetails.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'PaymentDetails',
          meta: {
            breadCrumb: 'Payment Details',
            title: 'Details',
            selected: true,
            permissionSlug: 'payment'
          }
        },
        {
          path: '/sales/payment/invoice/details/:invoiceId:paymentId',
          component: () => import('@/View/Sales/Payment/InvoiceDetails.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'InvoiceDetail',
          meta: {
            breadCrumb: 'Invoice Detail',
            title: 'Invoice Detail',
            selected: true,
            permissionSlug: ''
          }
        }
      ]
    },
    { // Sales setting
      path: '/sales/setting',
      component: () => import('@/View/Sales/main/index.vue'),
      hidden: false,
      icon: 'fas fa-cogs',
      name: 'SalesSettings',
      redirect: '/sales/setting/dashboard',
      meta: {
        breadCrumb: 'Setting',
        icon: 'settings',
        title: 'Settings',
        selected: true,
        permissionSlug: 'sales_settings',
        permissionList: ['']
      },
      children: [
        { // Sales dashboard start
          path: '/sales/setting/dashboard',
          component: () => import('@/View/Sales/Setting/setting.vue'),
          hidden: true,
          icon: 'dashboard',
          name: 'setting',
          meta: {
            color: '#26c6da',
            icon: 'settings',
            breadCrumb: 'dashboard',
            title: 'Dashboard',
            selected: false,
            permissionList: []
          }
        },
        {
          path: '/sales/setting/invoice/status',
          component: () => import('@/View/Sales/Setting/InvoiceStatus/InvoiceStatus.vue'),
          hidden: false,
          icon: 'fas fa-file-invoice',
          name: 'InvoiceStatus',
          meta: {
            color: '#f52549',
            breadCrumb: 'Invoice Status',
            name: 'InvoiceStatusList',
            title: 'Invoice Status',
            selected: false,
            permissionSlug: 'invoice_status',
            permissionList: ['isViewAll']
          }
        },
        {
          path: '/sales/setting/tax/rate',
          component: () => import('@/View/Sales/Setting/TaxRate/TaxRateList.vue'),
          hidden: false,
          icon: 'fas fa-coins',
          name: 'TaxRateList',
          meta: {
            color: '#15aabf',
            breadCrumb: 'TaxRate',
            title: 'TaxRate',
            selected: false,
            permissionSlug: 'tax_rate',
            permissionList: ['isViewAll']
          }
        },
        {
          path: '/sales/setting/payment/methods',
          component: () => import('@/View/Sales/Setting/PaymentMethod/PaymentMethodList.vue'),
          hidden: false,
          icon: 'far fa-credit-card',
          name: 'PaymentMethod',
          meta: {
            color: 'success',
            breadCrumb: 'Payment Methods',
            title: 'Payment Methods',
            selected: false,
            permissionSlug: 'payment_method',
            permissionList: ['isViewAll']
          }
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/View/Sales/Router/index.js